"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARROW_UP = exports.ARROW_DOWN = exports.ENTER = exports.ESCAPE = void 0;
exports.ESCAPE = 'Escape';
exports.ENTER = 'Enter';
exports.ARROW_DOWN = 'ArrowDown';
exports.ARROW_UP = 'ArrowUp';
//# sourceMappingURL=keyEvents.js.map